import { supabase } from "./supabase";
import type { Folder } from "@/types";

export async function listFolders(): Promise<Folder[]> {
  const { data, error } = await supabase
    .from("folders")
    .select("*")
    .order("created_at", { ascending: true });
  if (error) throw error;
  return (data as Folder[]) ?? [];
}

export async function createFolder(name: string, color?: string): Promise<Folder> {
  const trimmed = name.trim();
  if (!trimmed) throw new Error("Folder name required");
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");
  const { data, error } = await supabase
    .from("folders")
    .insert({ user_id: user.id, name: trimmed, color: color ?? null })
    .select()
    .single();
  if (error) throw error;
  return data as Folder;
}

export async function deleteFolder(id: string): Promise<void> {
  const { error } = await supabase.from("folders").delete().eq("id", id);
  if (error) throw error;
}

export async function setMeetingFolder(
  meetingId: string,
  folderId: string | null
): Promise<void> {
  const { error } = await supabase
    .from("meetings")
    .update({ folder_id: folderId })
    .eq("id", meetingId);
  if (error) throw error;
}

export async function setMeetingTags(
  meetingId: string,
  tags: string[]
): Promise<void> {
  const cleaned = Array.from(
    new Set(
      tags
        .map((t) => t.trim().toLowerCase())
        .filter((t) => t.length > 0 && t.length <= 32)
    )
  ).slice(0, 20);
  const { error } = await supabase
    .from("meetings")
    .update({ tags: cleaned })
    .eq("id", meetingId);
  if (error) throw error;
}
